import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const InstructionHeader = () => {
  const { t } = useTranslation();

  return (
    <Grid container direction="row" justifyContent="center">
      <Grid item>
        <Typography style={{ fontWeight: 600, fontSize: 18 }}>
          {t("documents.instructions")}:
        </Typography>
      </Grid>
    </Grid>
  );
};

export default InstructionHeader;
